/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum AccessLevel {
  STANDARD = 'STANDARD',
  ACCOUNT_MANAGEMENT = 'ACCOUNT_MANAGEMENT',
  ADMIN = 'ADMIN',
}
